<div class="container">
    <div class="go-to">
        <button class="non-anchor" (click)="goTo('general')">Qué es Ituran y porqué puede ayudarte</button>
        <button class="par-anchor" (click)="goTo('plans')">Elige al servicio ideal para ti</button>
        <button class="non-anchor" (click)="goTo('faq')">¿Cómo lo contratas?</button>
        <button class="par-anchor" (click)="goTo('howToPay')">¿Cómo se paga?</button>
        <button class="non-anchor" (click)="goTo('contratarAhora')">¡Contratar ahora!</button>
    </div>
</div>